import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getAddress(params) {
	return client.get("user/address-kiriminaja/data", {
		params: params,
	});
}

function getAddressDetail(params) {
	return client.get("user/address-kiriminaja/detail", {
		params: params,
	});
}

function addAddress(params) {
	return client.post("user/address-kiriminaja/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateAddress(params) {
	return client.post("user/address-kiriminaja/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function removeAddress(params) {
	return client.post("user/address-kiriminaja/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function setDefaultAddress(params) {
	return client.post("user/address-kiriminaja/use", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getAddress,
	getAddressDetail,
	addAddress,
	updateAddress,
	removeAddress,
	setDefaultAddress
};